import { startTransition, useOptimistic } from 'react';
import { useSearchParams } from 'react-router';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { parsePerPageQuery } from '@/utils';
import { PER_PAGE } from '@/utils/constants';

const { SMALL, MEDIUM, LARGE } = PER_PAGE;

export function DataTablePerPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [optimisticValue, setOptimisticValue] = useOptimistic(
    parsePerPageQuery(searchParams.get('per_page')),
  );

  function onValueChange(value: string) {
    const newValue = parseInt(value);

    startTransition(() => {
      setOptimisticValue(newValue);
      setSearchParams((prev) => {
        prev.set('page', '1');
        prev.set('per_page', value);

        return prev;
      });
    });
  }

  return (
    <div className="flex items-center gap-x-2">
      <p className="text-sm font-medium">Rows per page</p>
      <Select onValueChange={onValueChange} value={optimisticValue.toString()}>
        <SelectTrigger className="h-8">
          <SelectValue />
        </SelectTrigger>
        <SelectContent side="top">
          <SelectItem value={SMALL.toString()}>{SMALL}</SelectItem>
          <SelectItem value={MEDIUM.toString()}>{MEDIUM}</SelectItem>
          <SelectItem value={LARGE.toString()}>{LARGE}</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
